"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var supported_keys_json_1 = __importDefault(require("../config/supported-keys.json"));
var StandardKeys = {};
for (var key in supported_keys_json_1.default.keys) {
    if (Object.prototype.hasOwnProperty.call(supported_keys_json_1.default.keys, key)) {
        var deprecatedKeyName = supported_keys_json_1.default.keys[key].deprecatedKeyName;
        if (deprecatedKeyName && deprecatedKeyName.length > 0) {
            StandardKeys[deprecatedKeyName] = key;
        }
    }
}
exports.default = StandardKeys;
